export default {
    computed: {
        quotas() { return this.$store.getters.quotas },
    },
    methods: {
        // Setter
        setQuotas(quotas) { return this.$store.dispatch('defineCurrentQuotas', quotas) },
        // Getter
        getQuotas() { return this.quotas  },
        getQuotasByCountryCode(countryCode) { 
            return this.quotas.filter(quota => {
                //--- no country restriction
                if (quota.availableCountries.length == 0) {
                    return true;
                }

                //--- has country restriction
                return undefined !== quota.availableCountries.find(availableCountryCode => availableCountryCode == countryCode)
            }) 
        },
    },
}
